import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from "vue";
import type { Color } from "vuesax-alpha";

const __default__ = {
  name: "TcVsButton1",
};


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  color: ref<Color>(),
  content: String,
  height: String,
  icon: String,
  title: String,
  width: String,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_vs_button = _resolveComponent("vs-button")!

  return (_openBlock(), _createBlock(_component_vs_button, {
    class: "tc-vs-button-1",
    type: "flat",
    color: __props.color ? __props.color : 'discord',
    style: _normalizeStyle({ width: __props.width + 'px', height: __props.height + 'px' }),
    icon: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("h1", null, [
        _createElementVNode("i", {
          class: _normalizeClass('bx ' + __props.icon)
        }, null, 2),
        _createTextVNode(_toDisplayString(__props.title), 1)
      ]),
      _createElementVNode("p", null, _toDisplayString(__props.content), 1)
    ]),
    _: 1
  }, 8, ["color", "style"]))
}
}

})